import React from 'react';

const CashHandoverFromSalesReportHeader = () => (
    <h1>Cash Handover from Sales Report</h1>
);

export default CashHandoverFromSalesReportHeader;
